import { render, staticRenderFns } from "./BookingReview.vue?vue&type=template&id=81a2af8c&scoped=true"
import script from "./BookingReview.vue?vue&type=script&lang=js"
export * from "./BookingReview.vue?vue&type=script&lang=js"
import style0 from "./BookingReview.vue?vue&type=style&index=0&id=81a2af8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a2af8c",
  null
  
)

export default component.exports